import Faq from '../../templates/Faq';
import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * Description
 *
 * @typedef {Object} content
 *
 * @augments {Component<>}
 */
class FaqView extends Component {
	render () {
		const { content } = this.props;
		return <Faq content={content} />;
	}
}
export default withLanguageContext(FaqView);



// WEBPACK FOOTER //
// ./src/components/views/FaqView/FaqView.js